import { useEffect, useState } from 'react';
import axios from 'axios';
import ScholarshipCard from '@/components/ScholarshipCard';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ScholarshipsPage() {
  const [scholarships, setScholarships] = useState([]);
  const [filteredScholarships, setFilteredScholarships] = useState([]);
  const [countryFilter, setCountryFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchScholarships = async () => {
      try {
        const response = await axios.get(`${API}/scholarships?limit=50`);
        setScholarships(response.data);
        setFilteredScholarships(response.data);
      } catch (error) {
        console.error('Error fetching scholarships:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchScholarships();
  }, []);

  useEffect(() => {
    if (countryFilter === 'all') {
      setFilteredScholarships(scholarships);
    } else {
      setFilteredScholarships(scholarships.filter(sch => sch.country === countryFilter));
    }
  }, [countryFilter, scholarships]);

  const countries = ['all', ...new Set(scholarships.map(sch => sch.country))];

  return (
    <div className="py-12 bg-white">
      <div className="container mx-auto px-4 md:px-8 lg:px-12">
        <div className="mb-8">
          <h1 className="text-4xl md:text-5xl font-playfair font-bold text-foreground mb-4">Scholarships</h1>
          <p className="text-lg text-muted-foreground mb-6">Find funding opportunities for your education</p>
          
          <div className="flex items-center gap-4">
            <Select value={countryFilter} onValueChange={setCountryFilter}>
              <SelectTrigger className="w-48 rounded-sm" data-testid="country-filter">
                <SelectValue placeholder="Filter by country" />
              </SelectTrigger>
              <SelectContent>
                {countries.map(country => (
                  <SelectItem key={country} value={country}>
                    {country === 'all' ? 'All Countries' : country}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="h-64 bg-secondary animate-pulse rounded-sm" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="scholarships-grid">
            {filteredScholarships.map((scholarship) => (
              <ScholarshipCard key={scholarship.scholarship_id} scholarship={scholarship} />
            ))}
          </div>
        )}

        {!loading && filteredScholarships.length === 0 && (
          <div className="text-center py-12">
            <p className="text-muted-foreground">No scholarships found.</p>
          </div>
        )}
      </div>
    </div>
  );
}